import { Responsive, LinkButton } from '@cian/ui-kit';
import { FC } from 'react';

interface IAllOffersLinkButtonProps {
  link: string;

  onClick?: VoidFunction;
}

export const AllOffersLinkButton: FC<IAllOffersLinkButtonProps> = ({ link, onClick }) => {
  return (
    <>
      <Responsive desktop>
        <LinkButton href={link} size="L" theme="stroke_primary" fullWidth target="_blank" onClick={onClick}>
          Показать еще
        </LinkButton>
      </Responsive>
      <Responsive tablet phone>
        <LinkButton href={link} size="L" theme="fill_secondary" fullWidth onClick={onClick}>
          Еще объявления
        </LinkButton>
      </Responsive>
    </>
  );
};
